import { isPlainObject } from 'lodash';
import getHistoryValueRestoration from './getHistoryValueRestoration';
import getHistoryValueEndodontic from './getHistoryValueEndodontic';
import getHistoryValuePathology from './getHistoryValuePathology';
import getHistoryValuePeriodontal from './getHistoryValuePeriodontal';
import {
	ToothEndodontic,
	ToothPathology,
	ToothPeriodontal,
	ToothRestoration,
} from '../../../../graphql/graphql';

export type HistoryValueRecord = Record<string, unknown>;

export interface GetHistoryValueProps {
	type: string;
	value: HistoryValueRecord | null | undefined;
}

const isObjectValue = (
	v: HistoryValueRecord | null | undefined,
): v is Record<string, unknown> => isPlainObject(v);
const isRestorationValue = (
	v: HistoryValueRecord | null | undefined,
): v is ToothRestoration => isObjectValue(v);
const isPathologyValue = (
	v: HistoryValueRecord | null | undefined,
): v is ToothPathology => isObjectValue(v);
const isEndodonticValue = (
	v: HistoryValueRecord | null | undefined,
): v is ToothEndodontic => isObjectValue(v);
const isPeriodontalValue = (
	v: HistoryValueRecord | null | undefined,
): v is ToothPeriodontal => isObjectValue(v);

export function getHistoryValue({ type, value }: GetHistoryValueProps) {
	switch (type) {
		case 'missing':
			return value
				? 'patientTreatment.meddiDENT.history.missing'
				: 'patientTreatment.meddiDENT.history.notMissing';
		case 'to_be_extracted':
			return value
				? 'patientTreatment.meddiDENT.history.extracted'
				: 'patientTreatment.meddiDENT.history.notExtracted';
		case 'restoration':
			return isRestorationValue(value)
				? getHistoryValueRestoration(value)
				: JSON.stringify(value);
		case 'pathology':
			return isPathologyValue(value)
				? getHistoryValuePathology(value)
				: JSON.stringify(value);
		case 'endodontic':
			return isEndodonticValue(value)
				? getHistoryValueEndodontic(value)
				: JSON.stringify(value);
		case 'periodontal':
			return isPeriodontalValue(value)
				? getHistoryValuePeriodontal(value)
				: JSON.stringify(value);
		default:
			return JSON.stringify(value);
	}
}
